import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { RecipeContext } from "components/recipe/providers/RecipeProvider";
import { useAuthentication } from "authentication/AuthenticationContext";
import AdminRoute from "components/auth/AdminRoute";
import Login from "authentication/Login";
import MainMenu from "components/menuOptions/MainMenu";
import ProtectedRoute from "components/auth/ProtectedRoute";
import React, { useContext, useState } from "react";
import RecipeDetails from "components/recipe/RecipeDetails";
import RecipeList from "components/recipe/RecipeList";
import Signup from "authentication/Signup";

const AppRoutes = () => {
  const { recipes, isLoadingRecipes } = useContext(RecipeContext);
  const { user } = useAuthentication();
  const [recipeView, setRecipeView] = useState("all");
  const [filteredRecipes, setFilteredRecipes] = useState(null);
  const [isAddOpen, setIsAddOpen] = useState(false);
  // Use filtered recipes if available, otherwise use all recipes
  // found this was showing "my recipes pending" at the top of all recipes
  const collectionRecipes =
    recipeView === "mine"
      ? recipes.filter((recipe) => user && recipe.created_by === user.id)
      : recipes.filter(
          (recipe) =>
            recipe.status === "published" && recipe.is_private === false,
        );

  const collectionIds = new Set(collectionRecipes.map((recipe) => recipe.id));

  const displayRecipes =
    filteredRecipes === null
      ? collectionRecipes
      : filteredRecipes.filter((recipe) => collectionIds.has(recipe.id));

  const handleRecipeViewChange = (view) => {
    setRecipeView(view);
    setFilteredRecipes(null);
  };

  const handleOpenAdd = () => {
    setIsAddOpen((current) => !current);
  };

  return (
    <BrowserRouter>
      <MainMenu
        isAddOpen={isAddOpen}
        onFilter={setFilteredRecipes}
        recipes={collectionRecipes}
      />
      <main id="Section-List">
        <Routes>
          {/* Homepage */}
          <Route
            path="/"
            element={
              <RecipeList
                isLoading={isLoadingRecipes}
                onAdd={handleOpenAdd}
                onRecipeViewChange={handleRecipeViewChange}
                recipes={displayRecipes}
                recipeView={recipeView}
              />
            }
          />
          {/* SEO-friendly recipe URL */}
          <Route path="/recipes/:slug" element={<RecipeDetails />} />
          {/* Old recipe URL kept temporarily so old links still work */}
          <Route path="/recipeDetails/:id" element={<RecipeDetails />} />
          {/* Login */}
          <Route path="/login" element={<Login />} />
          {/* Signup */}
          <Route path="/signup" element={<Signup />} />

          {/* Protected routes - require login */}
          <Route
            path="/submit-recipe"
            element={
              <ProtectedRoute>
                {/* We'll build this component next */}
                <div>Submit Recipe Form (Coming Soon)</div>
              </ProtectedRoute>
            }
          />

          {/* Admin-only route */}
          <Route
            path="/admin"
            element={
              <AdminRoute>
                {/* We'll build this component next */}
                <div>Admin Dashboard (Coming Soon)</div>
              </AdminRoute>
            }
          />
          {/* Any unknown URL redirects to homepage */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        {/* <h6 className="Small-Font Justify-Center Green">
          As an Amazon Associate, I earn from qualifying purchases.
        </h6> */}
      </main>
    </BrowserRouter>
  );
};

export default AppRoutes;
